export const APPEARANCE_MODE_LIGHT = 'LIGHT' as const;
export const APPEARANCE_MODE_DARK = 'DARK' as const;

export const SPACING = 4 as const;

export const SHAPE_SQUARE = 'square' as const;
export const SHAPE_ROUNDED = 'rounded' as const;
export const SHAPE_CIRCULAR = 'circular' as const;

export const SIZE_X_SMALL = 'xSmall' as const;
export const SIZE_SMALL = 'small' as const;
export const SIZE_MEDIUM = 'medium' as const;
export const SIZE_LARGE = 'large' as const;
